import { ApiTagTypes, baseApi, IPaginatedResponse, IPaginatedBaseQuery } from './baseApi';
import { IFavorite } from '@biolibtech/biolib-js';

const favoritesApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        getFavorites: build.query<IPaginatedResponse<IFavorite>, IPaginatedBaseQuery>({
            query: (args) => ({
                url: '/favorites/',
                params: {
                    page: args.page ?? 1,
                    page_size: args.page_size ?? 10,
                },
            }),
            providesTags: [ApiTagTypes.favorites],
        }),
        addFavorite: build.mutation<IFavorite, { resourceUuid: string }>({
            query: (args) => ({
                url: '/favorites/',
                method: 'POST',
                body: { app: args.resourceUuid },
            }),
            invalidatesTags: [ApiTagTypes.favorites],
        }),
        removeFavorite: build.mutation<void, { favoriteUuid: string }>({
            query: (args) => ({
                url: `/favorites/${args.favoriteUuid}/`,
                method: 'DELETE',
            }),
            invalidatesTags: [ApiTagTypes.favorites],
        }),
    }),
});

export const { useGetFavoritesQuery, useAddFavoriteMutation, useRemoveFavoriteMutation } = favoritesApi;
